var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"#f7f7f7","padding":"15px","border-radius":"5px"}},[_c('h3',[_vm._v(_vm._s(_vm.question.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.question.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }